"use strict";

if (!customElements.get("product-form")) {
  // Validate before cart apps receive clicks on the main or sticky add button.
  window.addEventListener("click", evt => {
    const button = evt.target.closest(".product-submit-button, #sticky-add-to-cart-button");
    if (!button) return;
    const form = button.form || document.getElementById(button.dataset.productFormId);
    const trackerId = form?.querySelector('[name="properties[Tracker ID]"]');
    if (!trackerId || trackerId.disabled || trackerId.value.trim()) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    form.closest("product-form").validateCustomFields($(trackerId), true);
    trackerId.focus();
  }, true);
  customElements.define("product-form", class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.form.querySelector("[name=id]").disabled = false;
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");
      this.hideErrors = this.dataset.hideErrors === "true";
      const customFields = $(this.form).find("#product-metafields select, #product-metafields input").add($("#product-options #subscription"));
      if (customFields && customFields.length) {
        customFields.on("input", () => {
          this.validateCustomFields(customFields);
        });
        $(this.form).find(".product-submit-button").on("click", evt => {
          if (!this.validateCustomFields(customFields, true)) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
          }
        });
      }
      const productOptions = $("#product-options");
      if (!productOptions.length) {
        $("#product-metafields").show();
      }
    }
    validateCustomFields(customFields, showErrors) {
      let hasErrors = false;
      customFields.each((i, obj) => {
        const customField = $(obj);
        const isRequired = customField.prop("required");
        const isDisabled = customField.prop("disabled");
        const customFieldId = customField.attr("id");
        if (isRequired && !isDisabled) {
          const fieldValue = customFieldId === "product-properties-tracker-id" ? customField.val().trim() : customField.val();
          if (customFieldId === "subscription" && fieldValue !== "Please Select Subscription" || customFieldId !== "subscription" && fieldValue) {
            customField.removeClass("product-properties-error");
            $(this.form).find(".product-form__error-message-wrapper").attr("hidden", true);
          } else {
            if (showErrors) {
              let fieldName = customField.attr("name");
              if (fieldName) {
                fieldName = fieldName.substring(fieldName.indexOf("[") + 1, fieldName.lastIndexOf("]"));
              } else {
                fieldName = customFieldId.charAt(0).toUpperCase() + customFieldId.slice(1);
              }
              customField.addClass("product-properties-error");
              this.handleErrorMessage(`${fieldName} field is required.`);
            }
            hasErrors = true;
            return false;
          }
        }
      });
      const submitButtons = $(this.form).find(".product-submit-button");
      if (hasErrors) {
        submitButtons.find("#buy-button-text").text("Add to Cart");
        submitButtons.prop("type", "button");
      } else {
        submitButtons.find("#buy-button-text").text("Buy Now");
        submitButtons.prop("type", "submit");
      }
      return !hasErrors;
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      const customFields = $(this.form).find("#product-metafields select, #product-metafields input").add($("#product-options #subscription"));
      if (!this.validateCustomFields(customFields, true)) return;
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.getAttribute("aria-disabled") === "true") return;
      this.handleErrorMessage();
      submitButton.setAttribute("aria-disabled", true);
      submitButton.classList.add("loading");
      this.querySelector(".loading__spinner").classList.remove("hidden");
      const config = {
        headers: {
          "Content-Type": 'application/json',
          "Accept": 'application/javascript'
        },
        method: "POST"
      };
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append("sections", this.cart.getSectionsToRender().map(section => section.id));
        formData.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config).then(response => response.json()).then(response => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: formData.get("id"),
            errors: response.errors || response.description,
            message: response.message
          });
          this.handleErrorMessage(response.description);
          const soldOutMessage = submitButton.querySelector(".sold-out-message");
          if (!soldOutMessage) return;
          submitButton.setAttribute("aria-disabled", true);
          submitButton.querySelector("span").classList.add("hidden");
          soldOutMessage.classList.remove("hidden");
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          productVariantId: formData.get("id"),
          cartData: response
        });
        this.error = false;
        const quickAddModal = this.closest("quick-add-modal");
        if (quickAddModal) {
          document.body.addEventListener("modalClosed", () => {
            setTimeout(() => {
              this.cart.renderContents(response);
            });
          }, {
            once: true
          });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      }).catch(e => {
        console.error(e);
      }).finally(() => {
        submitButton.classList.remove("loading");
        if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
        if (!this.error) submitButton.removeAttribute("aria-disabled");
        this.querySelector(".loading__spinner").classList.add("hidden");
      });
    }
    handleErrorMessage() {
      let errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");
      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
